module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"forbidden_message":"You have not permission for the required action"},"es":{"forbidden_message":"Usted no tiene permisos para la accion requerida"}}')
  delete Component.options._Ctor
}
